export const J22 = {
  knights: 'Knights',
}
